import React from 'react'
import PropTypes from 'prop-types'

import { useOnClickOutside } from '../../lib/OnClickOutside'

export const ListActions = ({ data, modSchema, openFormEdit, del, openChildForm }) => {
  const [openOptions, setOpenOptions] = React.useState(false)

  const openOptionsRef = React.useRef()
  useOnClickOutside(openOptionsRef, () => setOpenOptions(false))

  return (
    <td>
      <ul className="trtui-list-inline trtui-hstack trtui-gap-2 trtui-mb-0">
        <li className="trtui-list-inline-item">
          <div className="trtui-dropdown">
            <button
              className={`trtui-btn trtui-btn-soft-secondary trtui-btn-sm trtui-dropdown ${
                openOptions && 'trtui-show'
              }`}
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={() => setOpenOptions(!openOptions)}
            >
              <i className="ri-more-fill trtui-align-middle" />
            </button>
            <ul
              ref={openOptionsRef}
              className={`trtui-dropdown-menu trtui-dropdown-menu-end ${
                openOptions && 'trtui-show'
              }`}
              style={{
                position: 'absolute',
                inset: '0px 0px auto auto',
                margin: '0px',
                transform: 'translate(0px, 22px)',
              }}
            >
              {modSchema.isRowForm && (
                <li>
                  <button
                    className="trtui-dropdown-item trtui-view-item-btn"
                    onClick={() =>
                      openChildForm(data[modSchema.rowForm.rowDataArray], modSchema.rowForm, data)
                    }
                  >
                    <i className="ri-user-add-line trtui-align-bottom trtui-me-2 trtui-text-muted" />
                    {modSchema.rowForm.formTitle}
                  </button>
                </li>
              )}
              <li>
                <button
                  className="trtui-dropdown-item trtui-view-item-btn"
                  onClick={() => openFormEdit(data, true)}
                >
                  <i className="ri-eye-fill trtui-align-bottom trtui-me-2 trtui-text-muted" />
                  View
                </button>
              </li>
              <li>
                <button
                  className="trtui-dropdown-item trtui-edit-item-btn"
                  onClick={() => openFormEdit(data)}
                  data-bs-toggle="modal"
                >
                  <i className="ri-pencil-fill trtui-align-bottom trtui-me-2 trtui-text-muted" />{' '}
                  Edit
                </button>
              </li>
              <li>
                <button
                  className="trtui-dropdown-item trtui-remove-item-btn"
                  data-bs-toggle="modal"
                  onClick={() => del(data)}
                >
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted" /> Delete
                </button>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </td>
  )
}

ListActions.propTypes = {
  data: PropTypes.object,
  modSchema: PropTypes.object,
  openFormEdit: PropTypes.func,
  del: PropTypes.func,
  openChildForm: PropTypes.func,
}
